import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['textarea']
  connect() {
    this.grow()
  }

  grow() {
    const textareaAutogrowWrap = this.element
    textareaAutogrowWrap.dataset.replicatedValue = this.textareaTarget.value
  }
}
